// export default FBLoginButton
import React, { CSSProperties, useEffect } from "react";

import { getDeviceIdAndUserSubScription } from "react-lib/apps/HISV3/common/sequence/GetUserSubScription";

import "./LoginButton.css";

type FacebookLoginButtonProps = {
  style?: CSSProperties;
  appId: string;
  deviceId?: string;
  disabled?: boolean;
  fbLoginText?: string;
  logoSrc?: string;
  logoStyle?: Record<string, any>;
  shimmer?: boolean;
  textStyle?: Record<string, any>;
  version: string;
  onCallback?: (data: any) => Promise<void>;
  onClick?: () => void;
  onLoading?: (loading: boolean) => void;
  onSiteSuccess?: (data: any) => void;
};

type FacebookLoginResponse = {
  authResponse?: {
    accessToken: string;
    userID: string;
  };
  status: string;
};

type FacebookUserResponse = {
  email: string;
  name: string;
  picture: any;
};

const FacebookLoginButton = React.forwardRef((props: FacebookLoginButtonProps, ref: any) => {
  useEffect(() => {
    loadFbLoginApi();
  }, []);

  // Facebook Login Logic
  const loadFbLoginApi = (): void => {
    globalThis.fbAsyncInit = () => {
      globalThis.FB.init({
        appId: props.appId,
        cookie: true,
        version: props.version,
        xfbml: true,
      });
      globalThis.FB.AppEvents.logPageView();
    };

    ((d, s, id) => {
      const fjs = d.getElementsByTagName(s)[0];

      let js: HTMLScriptElement;

      if (d.getElementById(id)) {
        return;
      }

      js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode?.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  };

  const responseFacebook = async (
    fbResponse: FacebookLoginResponse,
    deviceId: string,
    subscription: string
  ): Promise<void> => {
    if (fbResponse.status === "not_authorized" || fbResponse.status === "unknown") {
      return;
    }

    props.onLoading?.(true);

    if (fbResponse.authResponse?.accessToken && fbResponse.authResponse) {
      props.onSiteSuccess?.(fbResponse.authResponse);

      await globalThis.FB.api(
        "/me",
        "get",
        { fields: "email,name,picture" },
        async (data: FacebookUserResponse) => {
          await props.onCallback?.({ data, deviceId, fbResponse, subscription });

          props.onLoading?.(false);
        }
      );
    }
  };

  const checkLoginState = (deviceId: string, subscription: string): void => {
    globalThis.FB.getLoginStatus((response: FacebookLoginResponse) => {
      responseFacebook(response, deviceId, subscription);
    });
  };

  const handleFBClick = async (): void => {
    if (props.disabled || props.onClick) {
      if (!props.disabled) {
        props.onClick?.();
      }

      return;
    }

    let deviceId = props.deviceId || "";
    let subscription = "";

    if (!deviceId) {
      [deviceId, subscription] = await getDeviceIdAndUserSubScription(true);
    }

    globalThis.FB.login(
      (response: FacebookLoginResponse) => {
        if (response.authResponse) {
          checkLoginState(deviceId, subscription);
        }
      },
      { scope: "public_profile,email" }
    );
  };

  return (
    <div
      ref={ref}
      className={`facebookLoginButton ${props.shimmer && !props.disabled ? "shimmer" : ""}`}
      style={{ ...props.style }}
      onClick={handleFBClick}
    >
      <img style={props.logoStyle} alt="" src={props.logoSrc ?? ""} />
      <span style={props.textStyle}>{props.fbLoginText ?? "เข้าสู่ระบบด้วย Facebook"}</span>
    </div>
  );
});

FacebookLoginButton.displayName = "FacebookLoginButton";

export default FacebookLoginButton;
